<template>
  <div v-if="(local_page_keys !== null) && (local_page_keys_report !== null)" data-app>
    <div class="uk-card uk-card-default uk-card-small uk-width-1-1 uk-animation-fade" style="min-height: calc(100vh - 40px);">
      <!--шапка страницы-->
      <div class="uk-card-header">
        <div data-uk-grid class="uk-grid uk-flex-middle">
          <div class="uk-width-expand">
            <h3 class="uk-card-title uk-margin-remove-top">
              Просмотр заказа
<!--              {{ local_page_keys.title_admin_orders_history_page }} <span v-if="showForClient !== ''">{{ local_page_keys.title_admin_orders_history_for_client }} {{ showForClient }}</span>-->
            </h3>
          </div>
          <div v-if="showForClient !== ''">
          </div>
        </div>
      </div>
      <!--контент-->
      <div class="uk-card-body">
        <div v-if="loading">
          <v-progress-circular
              :width="2"
              indeterminate
              style="color: forestgreen"></v-progress-circular>
        </div>
        <div v-else>
          <template v-if="errorHistoryList === null">
            <!--Просмотр заказа-->
            <md-dialog
                :md-active.sync="showDialogOrder"
                :md-closed="true"
                :md-click-outside-to-close="false"
                :md-close-on-esc="false"
                class="tm-dialog-progress-report tm-dialog-admin-order-history" id="simpleDialog">
              <div>
                <div class="uk-grid uk-flex-middle" data-uk-grid>
                </div>
              </div>
                <div style="min-height: 600px; max-height: 80vh; overflow-y: auto;">
                  <v-card flat>
                    <v-card-text>
                      <div v-if="loadingOrderView">
                        <v-progress-circular
                            :width="2"
                            indeterminate
                            style="color: forestgreen"></v-progress-circular>
                      </div>
                      <div class="uk-position-relative tm-modal-page">
                        <div class="uk-grid uk-flex-middle" data-uk-grid>
                          <div class="uk-width-auto">
                            <h4>{{ this.local_page_keys_report.order_number }}: {{ this.orderNumber }}</h4>
                          </div>
                        </div>
                        <div class="uk-margin" v-if="!activeOrderReload">
                          <OrderView></OrderView>
                        </div>
                        <hr class="uk-margin-medium">
                        <h4 class="uk-margin">{{local_page_keys.title_previous_orders}}:</h4>
                        <prev-orders-block-for-admin :currentOrderId="currendOrderId"></prev-orders-block-for-admin>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
            </md-dialog>
          </template>
          <template v-else> {{ errorHistoryList }}</template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import OrderView from "@/pages/Dashboard/Pages/OrderView";
import PrevOrdersBlockForAdmin from "@/pages/Dashboard/Components/Admin/PrevOrdersBlockForAdmin";

export default {
  name: "OrderSimpleView",
  components: {
    OrderView,
    PrevOrdersBlockForAdmin,
  },
  data: () => ({
    showBrokenInfoDialog: false,
    showDialog: false,
    showDialogOrder: true,
    activeOrderReload: false,
    currendOrderId:null,
    local_page_keys: null,
    local_page_keys_report:null,
    headers: [],
    headersInfoTable: [],
    headersInfoBrokenOrderTable: [],
    headersParticularInfoTable: [],
    tab: null,
    tabInfo: null,
    modal_info: {},
    modal_broken_info: {},
    ordersHistoryList: {},
    errorHistoryList: null,
    showForClient: '',
    loading: true,
    loadingBrokenInfo: true,
    loadingOrderHistoryInfo: true,
    loadingOrderView:true,
    showParticularInfoTable: false,
    activeOrders: [],
    activeOrderKey: null,
    tabHeaders:[],
    fillingTab:[],
    choosenDefaultPeriod: [],

    signedOrderNumber: null,
    orderNumber: null,
    orderSignature: null,
  }),
  methods: {

    async openOrder(order_number, order_signature) {
      this.activeOrderReload = true;
      this.loadingOrderView = true;
      await this.$store.dispatch('order/setViewOrderSignedNumber', {'order_number':order_number, 'order_signature':order_signature});
      let data = await this.$store.getters['order/viewOrderSignedNumber'];
      if (undefined !== data.result) {
        this.currendOrderId = data.result.order;
        this.showDialogOrder = true;
        this.loading = false;
        this.loadingOrderView = false;
        this.activeOrderReload = false;
      } else {
        this.loading = false;
        this.showDialogOrder = false;
        UIkit.notification({message: "Error: Incorrect Order View URL", pos: 'top-center', status: 'danger', timeout: 15000});
      }

    },
    async parseOrderParams() {
      this.signedOrderNumber = this.$route.params.pathMatch;
      if (this.signedOrderNumber) {
        let params_arr = this.signedOrderNumber.split('-');
        if (params_arr.length == 2) {
          this.orderNumber = params_arr[0];
          this.orderSignature = params_arr[1];
          await this.openOrder( this.orderNumber, this.orderSignature);
        } else {
          UIkit.notification({message: "Error: Incorrect Order View URL", pos: 'top-center', status: 'danger', timeout: 10000});
        }
      }
    },
  },
  computed: {
    photoBeforeUrl() {
      return process.env.VUE_APP_API_BASE_URL.replace('api/v1', '');
    },
    filteredTabHeaders() {
      if (this.showForClient) {
        return this.tabHeaders.filter(item => item.value === 'ordersAll');
      } else {
        return this.tabHeaders;
      }
    },

  },
  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPage('admin_orders_history');
    this.local_page_keys_report = await this.$filtergetLocalisationPage('pro_retoucher_progress_report');
  },
  async created() {
    await this.parseOrderParams();
  }
}
</script>

<style scoped>
  /*Layout*/
  @import '../../../assets/css/uikit/grid.css';
  /*Utilities*/
  @import '../../../assets/css/uikit/background.css';
  @import '../../../assets/css/uikit/label.css';
  @import '../../../assets/css/uikit/width.css';
  @import '../../../assets/css/uikit/height.css';
  @import '../../../assets/css/uikit/flex.css';
  @import '../../../assets/css/uikit/margin.css';
  @import '../../../assets/css/uikit/padding.css';
  @import '../../../assets/css/uikit/position.css';
  @import '../../../assets/css/uikit/utility.css';
  @import '../../../assets/css/uikit/transition.css';
  @import '../../../assets/css/uikit/text.css';
  @import '../../../assets/css/uikit/overlay.css';
  @import '../../../assets/css/uikit/animation.css';
  @import '../../../assets/css/custom.css';
  .tm-val-error {
    border: 2px solid red;
    padding-bottom: 0;
  }
  .cursor {
    cursor: pointer;
  }
  .no_decorate {
    list-style-type: none;
  }
  .tm-history-tab .v-card__text {
    padding: 15px 0 0;
  }
  #simpleDialog {
    //z-index:150;
  }
</style>